import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "./Picktemplate.scss";

const TemplateListContainer = (props) => {
  //s const puppeteer = require('puppeteer');

  /**
   *  need to make request to the server and get the list of templates from the templates table
   * we need to have frontend logic which seperate premium templates in the frontend
   *
   */
  const path = process.env.REACT_APP_S3_PUBLIC_PATH;
  const [selectedClass, setSelectedClass] = useState(false);
  const [id, setId] = useState("");
  const [rand, setRand] = useState(0);
  const dispatch = useDispatch();

  const handleClick = (id, images, customization, type, templateData) => {
    props.setImage(images);
    // dispatch(templateGetParticulaActions(id))
    // localStorage.setItem('templateId', id);
    props.changeTemplate(id, customization, type, templateData);
    props.imgClick(id);
    setId(id);
  };
  useEffect(() => {
    if (props.templateId) {
      setId(props.templateId);
    }
  }, [props.templateId]);

  const handleTemplateClick = (
    id,
    images,
    customization,
    type,
    templateData
  ) => {
    props.changeTemplate(id, customization, type, templateData);
    setRand(1);
  };

  useEffect(() => {
    if (rand == 1) {
      props.sampleSet();
      setRand(0);
    }
  }, [rand]);

  return (
    <div className="template-container1">
      <div className="row">
        {props.usage == "free" &&
          props.data &&
          props.data
            .filter((data) => data.status == "1")
            .map((data) => {
              let image = JSON.parse(data.image, true);
              return (
                <div className="col-md-6 col-12">
                  <>
                    {id == data.template_code ? (
                      <>
                        <div style={{ position: "relative" }} className="mb-2">
                          <img
                            className="template-list-image selected_template"
                            variant="top"
                            src={data.image_compressed}
                            onClick={() =>
                              handleClick(
                                data.template_code,
                                image.key,
                                data.settings.customization,
                                data.usage,
                                data
                              )
                            }
                          />
                          <div className="mobile-use-template">
                            <div className="mobile-use-button">
                              <span>Used Template</span>
                            </div>
                          </div>
                          <div className="checkcircle">
                            <img
                              src="/images/checkwhite.svg"
                              alt="checkwhite"
                            />
                          </div>
                        </div>
                        <p className="template-list-title ">{data.name}</p>
                      </>
                    ) : (
                      <>
                        <div style={{ position: "relative" }}>
                          <img
                            className="template-list-image  "
                            variant="top"
                            src={data.image_compressed}
                            onClick={() =>
                              handleClick(
                                data.template_code,
                                image.key,
                                data.settings.customization,
                                data.usage,
                                data
                              )
                            }
                          />
                          <div className="mobile-use-template">
                            <div
                              className="mobile-use-button"
                              onClick={() =>
                                handleTemplateClick(
                                  data.template_code,
                                  image.key,
                                  data.settings.customization,
                                  data.usage,
                                  data
                                )
                              }
                            >
                              <span>Use this template</span>
                            </div>
                          </div>
                        </div>

                        <p className="template-list-title">{data.name}</p>
                      </>
                    )}
                  </>
                </div>
              );
            })}
      </div>

      {/* {props.usage == "2" &&
        props.paidTemplate &&
        // result.likes.filter((like) => like.likedById == userID)
        props.paidTemplate
          .filter((data) => data.status == "1")
          .map((data) => {
            let image = JSON.parse(data.image, true);

            return (
              <>
                {id == data.template_code ? (
                  <>
                    <div style={{ position: "relative" }} className="mb-2">
                      <img
                        className="template-list-image selected_template"
                        variant="top"
                        src={data.image_compressed}
                        onClick={() =>
                          handleClick(
                            data.template_code,
                            image.key,
                            data.settings.customization,
                            data.type,
                            data
                          )
                        }
                      />
                      <div className="mobile-use-template">
                        <div className="mobile-use-button">
                          <span>Used Template</span>
                        </div>
                      </div>
                      <div className="checkcircle">
                        <img src="/images/checkwhite.svg" alt="checkwhite" />
                      </div>
                    </div>
                    <p className="template-list-title">{data.name}</p>
                  </>
                ) : (
                  <>
                    <div style={{ position: "relative" }}>
                      <img
                        className="template-list-image  "
                        variant="top"
                        src={data.image_compressed}
                        onClick={() =>
                          handleClick(
                            data.template_code,
                            image.key,
                            data.settings.customization,
                            data.type,
                            data
                          )
                        }
                      />
                      <div className="mobile-use-template">
                        <div
                          className="mobile-use-button"
                          onClick={() =>
                            handleTemplateClick(
                              data.template_code,
                              image.key,
                              data.settings.customization,
                              data.usage,
                              data
                            )
                          }
                        >
                          <span>Use this template</span>
                        </div>
                      </div>
                    </div>
                    <p className="template-list-title">{data.name}</p>
                  </>
                )}
              </>
            );
          })} */}
    </div>
  );
};

export default TemplateListContainer;
